import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { MoireSymbol } from "@/components/MoireLogo";
import { assetForItem } from "@/lib/categoryAssets";

export default function SharedLook() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [comp, setComp] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/look/shared/${id}`).then(({ data }) => setComp(data.composition)).catch(() => setError(true));
  }, [id]);

  if (error) return <div className="max-w-lg mx-auto px-5 py-24 text-center">
    <p className="font-serif text-3xl text-[#F5F2EA]">This look isn't available.</p>
    <button onClick={() => navigate("/")} className="mt-8 border border-[#C8A97E] text-[#C8A97E] px-8 py-3 font-sans text-xs tracking-luxe uppercase hover:bg-[#C8A97E] hover:text-[#0D0D0D] transition-colors">Explore MOIRÉ</button>
  </div>;
  if (!comp) return <div className="max-w-lg mx-auto px-5 py-24 text-center font-sans text-sm text-[#8A8170]">Loading the look…</div>;

  const items = [...(comp.garments || []), ...(comp.accessories || [])];
  return (
    <div className="max-w-3xl mx-auto px-5 md:px-8 py-14 md:py-20">
      <div className="flex items-center gap-2.5 justify-center mb-8"><MoireSymbol size={30} /><span className="font-sans tracking-luxe text-[#F5F2EA] text-lg">MOIRÉ</span></div>
      <p className="text-center font-sans text-[10px] tracking-luxe uppercase text-[#C8A97E]">A MOIRÉ Look{comp.occasion ? ` · ${comp.occasion}` : ""}</p>
      <h1 className="text-center font-serif text-4xl md:text-5xl text-[#F5F2EA] mt-2">{comp.name}</h1>
      <div className="text-center font-serif text-5xl text-[#C8A97E] mt-4">{Number(comp.score).toFixed(1)}<span className="text-xl text-[#8A8170]"> / 10</span></div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-8">
        {(comp.garments || []).map((g, i) => {
          const src = assetForItem(g);
          return (
          <div key={i} className="border border-[#F5F2EA]/10 h-32 relative overflow-hidden bg-[#F5F2EA]">
            {src ? <img src={src} alt={g.name} loading="lazy" className="w-full h-full object-cover" />
              : <div className="w-full h-full" style={{ backgroundColor: g.color_hex }} />}
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0D0D0D] to-transparent p-2 pt-6"><p className="font-serif text-sm text-[#F5F2EA]">{g.color_name}</p></div>
          </div>
        );})}
      </div>

      {comp.why && <p className="font-serif italic text-lg text-[#F5F2EA]/85 mt-8 text-center max-w-xl mx-auto">{comp.why}</p>}

      <div className="mt-8 divide-y divide-[#F5F2EA]/8 border-t border-[#F5F2EA]/8 max-w-md mx-auto">
        {items.map((it, i) => {
          const src = assetForItem(it);
          return (
          <div key={i} className="flex items-center gap-3 py-2.5">
            <span className="h-8 w-8 border border-[#F5F2EA]/15 overflow-hidden bg-[#F5F2EA]" style={!src ? { backgroundColor: it.color_hex } : {}}>
              {src && <img src={src} alt="" loading="lazy" className="w-full h-full object-cover" />}
            </span>
            <span className="font-serif text-base text-[#F5F2EA] flex-1">{it.name}</span>
          </div>
        );})}
      </div>

      <div className="text-center mt-12">
        <p className="font-serif italic text-xl text-[#C8A97E]">Dress Up. Don't Mess Up.</p>
        <button onClick={() => navigate("/match")} className="mt-6 bg-[#C8A97E] text-[#0D0D0D] px-10 py-4 font-sans text-sm tracking-luxe uppercase hover:bg-[#E5C293] transition-colors">Style your own look</button>
      </div>
    </div>
  );
}
